
document.addEventListener("DOMContentLoaded", function () {
  const footer = document.querySelector('footer')
  const mobFacets = document.querySelector(".mobile-facets__open")
  const mobFacetsClose = document.querySelector(".mobile-facets__close")
  
  mobFacets?.addEventListener('click', function () {
    if(footer){
      footer.style.display = 'none'
    }
  })
  
  mobFacetsClose?.addEventListener('click', function () {
    if(footer){
      footer.style.display = 'block'
    }
  })
})



// pf custom popup
class PfEntryPopup extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.closeBtn = this.querySelector(".close_btn");
    this.closeBtn.addEventListener("click", this.closePopup.bind(this));
    this.addEventListener("click", (e) => {
      if (e.target === this) {
        this.closePopup();
      }
    });

    this.showPopup();
  }
  closePopup() {
    this.classList.remove("active");
  }
  showPopup() {
    const showOneTime = this.getAttribute("one-time");
    const isShow = window.localStorage.getItem("pfEntryPopup");
    window.addEventListener("load", () => {
      if (showOneTime === "true") {
        if (isShow !== "true") {
          this.classList.add("active");
          window.localStorage.setItem("pfEntryPopup", "true");
        }
      } else {
        this.classList.add("active");
      }
    });
  }
}
customElements.define("pf-entry-popup", PfEntryPopup);


// PF Wholesale Management
class WholesaleManagement extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    if (!this.isWholesaler && this.hasWholesaleItems()) {
      this.clearWholesaleItems();
    }
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  get isWholesaler() {
    return this.dataset.customerType == "wholesaler";
  }

  get cartProducts() {
    return JSON.parse(this.dataset.cartProducts || "[]");
  }

  get wholesaleCollections() {
    return this.dataset.wholesaleCollections?.split(",") || [];
  }

  get cart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  hasWholesaleItems() {
    return this.cartProducts.some(product => {
      const productCollections = product.collections?.split(",") || [];

      return productCollections.some(col =>
        this.wholesaleCollections.includes(col.trim())
      );
    });
  }

  // async clearWholesaleItems() {
  //   const sections = this.cart.getSectionsToRender().map(s => s.id);

  //   try {
  //     const response = await fetch(`/cart/clear.js?sections=${sections.join(",")}`, {
  //       method: "POST",
  //       headers: {
  //         "X-Requested-With": "XMLHttpRequest",
  //       }
  //     });

  //     const json = await response.json();

  //     this.cart.renderContents(json, false);
  //   } catch (err) {
  //     console.error("Failed to clear wholesale items:", err);
  //   }
  // }

  async clearWholesaleItems() {
    try {
      await fetch("/cart/clear.js");
      window.location.reload();
    } catch (err) {
      console.error("Failed to clear wholesale items:", err);
    }
  }


  redirect(ifNotType, from, to) {
    if (this.dataset.customerType != ifNotType) {
      const path = window.location.pathname;

      if (path.includes(from)) {
        location.replace(to);
      }
    }
  }
}


if(!customElements.get("pf-wholesale-management")) {
  customElements.define("pf-wholesale-management", WholesaleManagement);
}

// Wholesaler login button
document.addEventListener("DOMContentLoaded", () => {
  const loginBtn = document.querySelector(".pf-wholesale-login button");
  const logoutBtn = document.querySelector(".pf-wholesale-logout button");

  loginBtn?.addEventListener("click", e => {
    e.preventDefault();

    window.location = "/account/login";
  });

  logoutBtn?.addEventListener("click", async e => {
    e.preventDefault();

    await fetch("/cart/clear.js");

    window.location = "/account/logout";
  });


  // quantity
  // const quantityInput = document.querySelector(".product-form__quantity quantity-input .quantity__input");
  // const price = document.querySelector(".product__info-wrapper .price__container .price-item .money");

  // if (quantityInput && price) {
  //   const basePrice = price.innerText;

  //   function updatePrice() {
  //     // Extract numeric value from the price
  //     const originalPrice = parseFloat(basePrice.replace(/[^0-9.-]+/g, ""));

  //     // Extract the currency symbol or any non-digit prefix/suffix
  //     const currencyPrefix = basePrice.match(/^[^\d]+/)?.[0] || "";
  //     const currencySuffix = basePrice.match(/[^\d]+$/)?.[0] || "";

  //     const productType = quantityInput.getAttribute("product-type");
  //     let quantity = parseFloat(quantityInput.value) || 1;

  //     if(productType.includes("its_fabric")){
  //       quantity = parseFloat(quantityInput.nextElementSibling.value) || 1;
  //     }
      
  //     let newPrice = originalPrice * quantity;

  //     // Keep original currency formatting
  //     price.innerText = `${currencyPrefix}${newPrice}${currencySuffix}`;
  //   }

  //   updatePrice();

  //   quantityInput.addEventListener("change", () => {
  //     updatePrice();
  //   });
  // }

});


// cart
(function (ns, originalFetch) {
  if (typeof originalFetch !== 'function') return;

  ns.fetch = function (...args) {
    const responsePromise = originalFetch.apply(this, args);

    responsePromise.then(async (res) => {
      if (!res.url.includes('cart/change')) return;

      const data = await res.clone().json().catch(() => null);
      if (!data?.items?.length) return;

      const changedItem =
        data?.items_added?.[0] || data?.items_removed?.[0];

      if (!changedItem) return;

      syncAddonQuantities(data, changedItem.sku);
    });

    return responsePromise;
  };

  async function syncAddonQuantities(cart, sku) {
    const mainProduct = cart.items.find(item => item.sku === sku);
    if (!mainProduct) return;

    const addons = cart.items.filter(
      item => item.properties?.SKU === sku
    );

    if (!addons.length) return;

    const updates = addons.reduce((acc, item) => {
      acc[item.key] = mainProduct.quantity;
      return acc;
    }, {});

    await fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    });
  }
})(window, window.fetch);